module.exports = __webpack_public_path__ + "img/leitong.b266568d.png";